export default "__VITE_ASSET__DQq5higN__"